<template> 
  <section>
  <div>
    <header :style="{'background': '#F5F5F7'}">
      <div class="container-fluid">
        <div class="row justify-content-center">
				<img class="logo-header" src="../img/logo-ucm-header.png" alt="Logo UCM"/>
        </div>
		
      </div>
    </header>
   
    <!--Banner principal success-->
	<div class="row" v-if="success">
		<div class="container-fluid text-center">
			<div class="alert alert-success fade show text-center" role="alert">
				<h1>Felicidades, tu compra ha sido exitosa!</h1> 
				<h5>Recibirás en los próximos minutos un correo de confirmación </h5>
				<h5>con los detalles y el contrato de prestación de servicios. </h5>
			</div>
		</div>
	</div>

	 <!--Banner principal fail-->
	<div class="row" v-if="failured">
		<div class="container-fluid text-center">	
			<div class="alert alert-danger	 fade show text-center" role="alert">
				<h1>Error!</h1> 
				<h5>No se pudo completar la transaccion</h5>
				<h5>vuelve a intentar utilizando otro medio de pago.</h5>
					<a href="#" @click="navigatesToForm" :style="{'position': 'absolute', 'top': '0', 'right': '0', 'width': '50px', 'text-decoration': 'none'}">
						<span aria-hidden="true">&times;</span>
					</a>
			</div>
		</div>
	</div>

    <div class="container-fluid banner_principal">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <p>Tu iPhone pide ayuda cuando tú no puedes</p>
              <h1>Ayuda rápida en el momento que más lo necesitas</h1>
              <p>Protégete con el servicio de SOS Rescate prestado por UCM.</p>
              <br></br>
				<p>Siéntete tranquilo y protegido las 24hrs del día en situaciones  que pongan en<br> riesgo tu vida por accidentes traumáticos o acciones de terceros, como:</p>
            </div>
          
            <div class="col-12 lista">
              <ul>
                <li><p>Accidentes automovilísticos</p></li>
                <li><p>Portonazos</p></li>
                <li><p>Caídas desde altura</p></li>
                <li><p>Accidentes traumáticos</p></li>
              </ul>
            </div>
          </div>
          <div class="col-12 text-center">
            <a href="#" @click="navigatesToForm" class="btn boton_negro">Quiero contratar el servicio</a>
          </div>
        </div>
    </div>
    
		<!--Fin Banner principal desk-->

		<!--Sección SOS Rescate-->
		<div class="container-fluid seccion2">
			<div class="container align-middle">
				<div class="row">
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 bloque_rescate">
						<h1>SOS Rescate</h1><br>
						<p>Con la función de detección de choques la ayuda es automática. <strong>Tu iPhone o Apple
								Watch¹ pueden detectar si sufres un accidente automovilístico grave</strong> y enviar un
							mensaje a tus contactos de emergencia.<br><br>

							<strong>Incluye el número de</strong> <a href="" class="linkrescate"><strong> SOS Rescate
								</strong> </a>como tu contacto de emergencias para que nuestros equipos médicos sean los
							primeros en asistirte en caso de un accidente.<br><br>
						</p>
						<div class="disclaimer">
						<h4>¹En el caso de Iphone 14 y Watch serie 8, el envío del mensaje es automático. En otras
							series es el usuario quien debe enviar el mensaje de forma manual.</h4>
					</div>
					</div>
          
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 img_iphone">
						<img src="../img/ucm-sos-rescate-2.png" class="img-fluid" alt="Mujer hablando por teléfono">
					</div>
					
				</div>
				<!--Fin Sección SOS Rescate-->

				<br><br><br><br>

				<!--Bloque Plan Anual-->
				<div class="row grancobertura text-center">
					<div>
						<p>Gran Cobertura y Beneficios</p>
						<h1>Plan Anual activo las 24 horas,<br> los 7 días de la semana</h1>
					</div>

				</div>
				<!--Fin Bloque Plan Anual-->

				<br><br><br><br>

				<!--Sección Cobertura Nacional-->
				<div class="row">
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 bloque_cobertura">
						<h1>Cobertura a Nivel Nacional*</h1><br>
						<p>Siéntete seguro con SOS Rescate, <strong>servicio de rescate terrestre en caso de Accidente
								de Riesgo Vital,</strong> o victima de acciones de terceros como accidentes
							automovilísticos, encerronas, portonazos, caídas desde altura o cualquier evento
							traumático.<br><br>

						</p>
						<h4>*La Cobertura Nacional funciona con recursos propios o coordinando recursos de terceros
							privados y/o públicos, en las áreas donde existan prestadores. </h4>
						<br><br>
						<a href="" @click="navigatesToForm" class="btn boton_azul">Me interesa SOS Rescate</a>


					</div>
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
						<img src="../img/ambulancia-ucm-1.png" class="img-fluid img_ambulancia" alt="Ambulancia">
					</div>
				</div>
			</div>
		</div>
		<!--Fin Sección Cobertura Nacional-->

		<!--Sección Recibe asistencia-->
		<div class="container-fluid banner_secundario">
			<div class="container">
				<div class="row text-center">
					<div class="col-12">
						<h1>Recibe asistencia en caso de <br>riesgo vital por accidentes</h1><br>
						<p>Siéntete tranquilo y protegido las 24hrs del día en situaciones que pongan en riesgo <br> tu vida
							por accidentes traumáticos o acciones de terceros, como:</p>
					</div>
				</div>
				<br><br>
				<div class="row justify-content-center">
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 icono1">
						<img class="icono" src="../img/iconos/svg/hueso-roto.svg">
						<h5><strong>Accidentes<br> traumáticos</strong></h5>
					</div>
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 icono2">
						<img class="icono" src="../img/iconos/svg/choque.svg">
						<h5><strong>Accidentes <br> automovilísticos</strong></h5>
					</div>
				</div>
				<br><br>
				<div class="row justify-content-center">
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 icono1">
						<img class="icono" src="../img/iconos/svg/robo.svg">
						<h5><strong>Portonazos</strong></h5>
					</div>
					<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 icono2">
						<img class="icono" src="../img/iconos/svg/caida.svg">
						<h5><strong>Caídas desde <br>altura</strong></h5>
					</div>
				</div>

			</div>
		</div>
		<!--Fin Sección Recibe asistencia-->

		<!--Sección Beneficios-->
		<div class="container-fluid">
			<div class="container">
				<div class="row beneficios justify-content-center">
					<div class="col-12  text-center">
						<h1><strong class="linkrescate">Al contratar SOS Rescate</strong> tendrás acceso a todos estos beneficios por un pago único de <strong class="linkrescate">1UF anual</strong></h1><br>
					</div>

					<div class="col-12 lista2">
						<ol :style="{'font-size': '1em'}">
							<li><p>Plan anual activo la 24 hrs. del día, los 365 días del año.</p></li>
							<li><p>Cobertura a Nivel Nacional. *</p></li>
							<li><p>Conexión directa a través de los contactos de emergencia en tu Iphone y/o Apple Watch.</p></li>
							<li><p>Traslado terrestre en ambulancia en caso de riesgo vital por accidente traumático o acciones de terceros.</p></li>
							<li><p>Cobertura de gastos ambulatorios derivados de la atención médica en la ambulancia.</p></li>
							<li><p>Asistencia a tus acompañantes en caso de accidentes automovilísticos con riesgo vital.</p></li>
						</ol>
					</div>

					<br>
					<div class="col-12 text-center">
						<a href="" class="btn boton_azul" @click="navigatesToForm">Quiero contratar el servicio</a>
						<br><br>
						<p class="lista2 justify-content-left">*Recuerda: La Cobertura Nacional funciona con recursos propios o coordinando recursos de terceros privados y/o públicos, en las áreas donde existan prestadores. </p>
					</div>
				</div>
			</div>
    </div>
		<!--Fin Sección Beneficios-->

		<!--Banner Políticas-->
		<div class="container-fluid politicas">
			<div class="container">
				<div class="row">
					<img class="logo_footer" src="../img/logo-ucm-footer.png" alt="Logo UCM">
					<p>Nuestra política de términos y condiciones fue elaborada para reafirmar nuestro compromiso con la seguridad, privacidad y transparencia de los usuarios y clientes de los servicios de rescate de Unidad Coronaria Móvil entregados en conjunto por Unidad Coronaria Móvil S.A, UCM Servicios Limitada, Sociedad Médica De Emergencia Cardiológica V Región SpA, y su Red Nacional, de ahora en adelante UCM.<br>
          Esta política de términos y condiciones abarca a nivel general los alcances, responsabilidades y beneficios obtenidos por los beneficiarios de UCM. Es importante señalar que los servicios propuestos y los contenidos de este sitio son de responsabilidad exclusiva de UCM y para cualquier otro sitio externo UCM no se hace responsable por información entregada por otros medios. Por ello, recomendamos a los usuarios que, al hacer clic en enlaces que llevan a sitios web externos, consulte siempre las respectivas políticas de privacidad antes de suministrar sus datos o informaciones.
          Recordamos que estos términos y condiciones definidos por UCM están sujetos a constantes mejoras y perfeccionamientos. Por lo que no representa en exactitud la información detallada en el contrato del servicio solicitado y solo a través del contrato las condiciones definitivas del servicio serán detalladas al beneficiario.<br>
          Caracteristicas:<br>
          (i) Servicio: El servicio corresponde a la atención de rescate médico en ambulancia terrestre hasta el centro hospitalario más cercano, a los clientes que contraten esta asistencia, en caso que sufran un accidente traumático o sean víctimas de una acción de terceros, que derive en una condición de salud con riesgo vital; tales como accidentes automovilísticos, encerronas, portonazos, caídas o cualquier evento traumático.<br>
          *(ii) Cobertura: La cobertura es a nivel nacional 24x7, con recursos propios de UCM o coordinando recursos de terceros privados y/o públicos, donde los hubiera. UCM no será responsable de prestar el servicio en caso de que no existan prestadores, ya sea privados o públicos, donde se produzca un requerimiento de atención.<br>
          (iii) Beneficiario: El propietario del número de teléfono asociado a la contratación de esta asistencia será el único beneficiario de la misma.<br>
          (iv) Alcance: En caso el beneficiario sufra un accidente traumático o sea víctima de una acción de terceros, que derive en una condición de salud con riesgo vital, la presente asistencia cubrirá los gastos de traslado terrestre en ambulancia al Centro Hospitalario más cercano, los gastos ambulatorios de la atención médica en la ambulancia y los medicamentos e insumos usados en dicha atención, luego de aplicar la cobertura de la previsión de salud y seguros complementarios del beneficiario, con un tope de 2 (dos) eventos anuales por beneficiario. Se establece que los servicios prestados por UCM tienen las condicionantes propias de una primera atención de emergencia médica con riesgo vital por lo que la formulación de un diagnóstico definitivo y su tratamiento será responsabilidad del médico tratante o especialista del beneficiario, según corresponda.<br>
          (v) Definición de Riesgo Vital: Para los efectos de este servicio, se define como emergencia médica con riesgo vital, a toda condición de salud o cuadro clínico que implique riesgo vital y/o secuela funcional grave para una persona de no mediar la atención médica inmediata e impostergable. En caso de un accidente o acción violenta de terceros, que derive en una situación de salud con riesgo vital, el beneficiario debe accionar el mensaje de emergencia de su equipo móvil que será recepcionado en el Centro de Servicio de UCM, que opera durante las 24 horas y los 365 días del año. Al llegar el mensaje de SOS con la ubicación geográfica a través de GPS del teléfono móvil del beneficiario, un profesional de salud capacitado en rescate se comunicará con éste y evaluará su estado de salud. Si el beneficiario se encuentra en riesgo vital, se procederá al envío de una ambulancia para realizar el rescate y posterior trasladado al centro asistencial más cercano.<br>
          (vi) Reservas a la contratación: La contratación de la asistencia será realizada en forma directa por el cliente a UCM. UCM se reserva el derecho de excluir de la venta a clientes que no califiquen para este servicio de acuerdo con lo estipulado en las presentes condiciones particulares.<br>
          (vii) Periodo de Cobertura / Servicio: La asistencia tiene un período de cobertura de 12 meses, el cual se activará 48 horas hábiles posterior a la fecha de contratación. Al término del período de cobertura, el cliente podrá renovar el beneficio en las condiciones que se encuentren vigentes en ese momento. UCM se reserva el derecho de excluir la renovación a clientes con alta siniestralidad.<br>
          (viii) Obligaciones del cliente: Una vez contratada la asistencia, el beneficiario deberá configurar el servicio a través del ingreso de los números de emergencia de UCM, indicados en el formulario de contratación, en sus contactos para emergencia de su IPhone o Apple Watch.<br>
          (ix) Procedimiento de evaluación: La evaluación y requerimiento de rescate del beneficiario será realizado por el personal de salud de UCM conforme al protocolo establecido en el Modelo Triage de ESI (Emergency Severity Index), Si el beneficiario se encuentra en riesgo vital producto de una accidente traumático o acción de terceros, lo cual de acuerdo con el protocolo Triage ESI corresponde exclusivamente a niveles ESI1, se procederá al rescate. La categorización ESI de cualquier requerimiento de atención será realizada exclusivamente por el Centro de Servicios de UCM y se hará según la información proporcionada por el beneficiario o quien se comunique a nombre de éste.
          </p>
				</div>
			</div>
		</div>
  	</div>
	<!--Fin Banner Políticas-->

  </section>
</template>

<script>
	import axios from "axios";
	import Swal from 'sweetAlert2';

	const URL_DEV_MAILGUN = "http://localhost:3000/sendEmail";
	const URL_PROD_MAILGUN = "https://35.87.22.14:8443/sendEmail";
	const URL_DEV_CONFIRM = "http://localhost:3000/confirmTransaction";
	const URL_PROD_CONFIRM = "https://35.87.22.14:8443/confirmTransaction";


export default {
  data() {
    return {
		success: false,
		failured: false,
	}	
  },

  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    this.sendEmail();
  },

  methods: {
    async sendEmail() {
      const currentURL = window.location.href;
      const controlPayment = currentURL.split('?');

      if(controlPayment.length > 1) {
        const token = controlPayment[1].split('=')[1].split('#')[0];
        
		// Confirmar la transaccion
        const option = {
          url: URL_PROD_CONFIRM,
          method: "POST",
          header: {
            "Content-Type": "application/json",
            },
            data: {
              token: token
            }
        }

        axios(option).then(async response => {
			console.log(response);
          if (response.data.data) {
			this.success = true;
			this.failured = false;

			setTimeout(() => {
				this.success= false;
				window.location.replace('https://ucm-landingpage.s3.sa-east-1.amazonaws.com/index.html');
				// window.location.replace('http://localhost:8080');
			}, 60000);
          } 
		  else {
			this.successs = false;
			this.failured = true;
			console.log('Error en la adquisición del servicio!');
		  }
        }).catch(error=> console.log('Error services: ', error));
      } else {
        console.log('Bienvenido Web UCM')
      }
    },

    navigatesToForm(event) {
      event.preventDefault();
      this.$router.push('/form');
    },

	closeSuccessMessage() {
		this.success = false;
	}

    // handleScroll: function() {
    //   if (this.scTimer) return;
    //   this.scTimer = setTimeout(() => {
    //     this.scY = window.scrollY;
    //     clearTimeout(this.scTimer);
    //     this.scTimer = 0;
    //   }, 100);
    // },
    // toTop: function() {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: "smooth"
    //   });
    // },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/HomePage.vue